import React, { useState, useEffect } from 'react';
import { ReactSortable } from 'react-sortablejs';
import './ProjectList.scss';
import { Loader } from '../../components/Loader/Loader.jsx';
import Axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../../config.js';
import { BackButton } from '../../components/BackButton/BackButton.jsx';
import { ModalMessage } from '../../components/ModalMessage/ModalMessage.jsx';
import { Logout } from '../../components/Logout/Logout.jsx';

export const ProjectList = () => {
	const [projects, setProjects] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [message, setMessage] = useState(null);

	const getProjects = async () => {
		setLoading(true);
		try {
			const { data: response } = await Axios.get(`${API_URL}/projects`);
			setProjects(response.data);
		} catch (error) {
			console.error(error);
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		getProjects();
	}, []);

	const deleteProject = async (id) => {
		const confirm = window.confirm(
			'¿Estás seguro de que quieres eliminar el proyecto?'
		);
		if (!confirm) return;
		try {
			const { data: response } = await Axios.delete(
				`${API_URL}/projects/${id}`
			);
			setMessage(response.message);
			getProjects();
		} catch (error) {
			console.error(error);
			setError(error.message);
		}
	};

	const handleSortUpdate = async (newOrder) => {
		const orderedIds = newOrder.map((project) => project._id);
		if (!Array.isArray(orderedIds) || orderedIds.length === 0) return;

		try {
			const { data: response } = await Axios.patch(
				`${API_URL}/projects/order`,
				{ orderedIds },
				{
					headers: {
						'Content-Type': 'application/json',
					},
				}
			);
			setMessage(response.message);
		} catch (error) {
			console.error('❌ Error al actualizar orden:', error);
			setError('Error al actualizar el orden de los proyectos');
		}
	};

	return (
		<div className='ProjectList'>
			{loading && <Loader />}
			<div className='container'>
				<BackButton to='/dashboard' text='Dashboard' />

				<Logout />
				<br />
				<h3>LISTADO DE PROYECTOS</h3>

				{error && (
					<ModalMessage
						type='error'
						message={error}
						onClose={() => setError(null)}
					/>
				)}
				{message && (
					<ModalMessage
						type='success'
						message={message}
						onClose={() => setMessage(null)}
					/>
				)}

				{projects.length === 0 ? (
					<h4>No hay proyectos todavía</h4>
				) : (
					<ReactSortable
						list={projects}
						setList={setProjects}
						ghostClass='dropArea'
						handle='.dragHandle'
						filter='.ignoreDrag'
						preventOnFilter={true}
						onEnd={({ oldIndex, newIndex }) => {
							if (oldIndex !== newIndex) {
								const newOrder = [...projects];
								const [movedItem] = newOrder.splice(
									oldIndex,
									1
								);
								newOrder.splice(newIndex, 0, movedItem);
								setProjects(newOrder);
								handleSortUpdate(newOrder);
							}
						}}
					>
						{projects.map((project) => (
							<div
								className='project dragHandle'
								key={project._id}
							>
								<img
									src={project.cover?.secure_url}
									alt='project'
								/>
								<h4>{project.name}</h4>
								<div className='btn-container'>
									<Link
										className='editButton'
										to={`/edit-project/${project._id}`}
									>
										<img
											className='editIcon'
											src={require('../../assets/icons/editar.png')}
											alt='edit-icon'
										/>
									</Link>
									<button
										className='deleteButton'
										onClick={() =>
											deleteProject(project._id)
										}
									>
										X
									</button>
								</div>
							</div>
						))}
					</ReactSortable>
				)}
			</div>
		</div>
	);
};
